import GraphsContainer from './GraphsContainer';

export default GraphsContainer;
